import ouiStyle from '@goldwasserexchange/oui-style';
import * as React from 'react';
import { NewsLetterBoxInputContent } from '../../../../../../../../../../../../../../../NewsletterBox/components/input/components';

export const ArticleNewsLetterBoxInputContent = (props: {
  name: string,
  type: React.InputHTMLAttributes<HTMLInputElement>['type'],
  placeholder: string,
}) => {
  const {
    name,
    type,
    placeholder,
  } = props;
  return (
    <NewsLetterBoxInputContent
      name={name}
      type={type}
      placeholder={placeholder}
      backgroundColor={ouiStyle.Constants.Colors.fade}
    />
  );
};
